import "@/assets/resize.js"
import Vue from 'vue'
import App from './App.vue'
import VueResource from 'vue-resource'
import 'vant/lib/index.css'
import { Toast } from 'vant'
import VueClipboard from 'vue-clipboard2'

// import Vconsole from 'vconsole'
// let vConsole = new Vconsole()
// Vue.use(vConsole)


Vue.config.productionTip = false
Vue.use(VueResource)
Vue.use(Toast)
Vue.use(VueClipboard)
Toast.setDefaultOptions({ duration: 2000, position:'bottom'})

// var config = {
// 	"SITE_ROOT":'//ff.com/',
// 	"API_URL" : '//ff.com/index.php/api',
// 	"API_ROOT" : '//ff.com/index.php/api/',
// 	"IMAGE_UPLOAD_URL" : '//ff.com/index.php/upload/upload_file/',
// }
var config = {
  "SITE_ROOT":'//ff.com/',
  "API_URL" : '//ff.com/index.php/api',
  "API_ROOT" : '//ff.com/index.php/api/',
  "IMAGE_UPLOAD_URL" : '//ff.com/index.php/upload/upload_file/',
}
new Vue({
  render: h => h(App),
}).$mount('#app')

Vue.http.interceptors.push({

    // request: function (request) {
    //     // post 插入CSRF信息
    //     if (request.method === 'post') {
    //         if (request.data instanceof FormData) {
    //             request.data.append(data.csrf_name, data.csrf_token);
    //             request.data.append('app', window.app);
    //         } else {
    //             request.data[data.csrf_name] = data.csrf_token;
    //             request.data.app = window.app;
    //         }
    //     } else {
    //         request.params.app = window.app;
    //     }
    //     if (request.url !== 'user/myinfo') {
    //         NProgress.start();
    //     }
    //     return request;
    // },

    response: function (response) {
        if (!response.ok) {
			Toast('请求失败');
            return response;
        }
        if (response.data && response.data.code != 0) {
            response.ok = false;
            if (response.request.url === 'user/myinfo') {
				Toast('同步用户数据失败');
            } else {
				Toast('请求错误');
            }
        }
        return response;
    }

});

// function parseQuery(query) {
//   query = query || location.search || location.href.split('?')[1]
//   var result = {}
//   if(query==undefined){
// 	return result
//   }
//   var a = (query[0] === '?' ? query.substr(1) : query).split('&')
//   for (var i = 0; i < a.length; i++) {
//     var b = a[i].split('=')
//     result[decodeURIComponent(b[0])] = decodeURIComponent(b[1] || '')
//   }
//   return result
// }

// Vue.config.query = parseQuery()

Vue.http.options.root = config.API_URL

Vue.http.options.emulateJSON = true

Vue.http.options.emulateHTTP = true

Vue.http.options.timeout = '10000'

// Vue.http.get(`user/profile/${Vue.config.query.uid}`).then(function(){
// 	// console.log(data.body.data)
// })
